import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';
import Breadcrumb from '../../../components/feature/Breadcrumb';
import FAQSchema from '../../../components/feature/FAQSchema';
import { useEffect } from 'react';

export default function SakaryaPage() {
  useEffect(() => {
    document.title = 'Sakarya Fiber Optik ve Güvenlik Sistemleri | Fabrika Fiber Altyapı';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Sakarya fiber kablo tamiri, fabrika fiber altyapı, fusion splicing, OTDR test, IP kamera sistemleri. Sakarya OSB güvenlik çözümleri.');
    }

    // Canonical link
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `${import.meta.env.VITE_SITE_URL}/bolgeler/sakarya`;
    document.head.appendChild(canonical);

    // Open Graph tags
    const ogTitle = document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    ogTitle.content = 'Sakarya Fiber Optik ve Güvenlik Sistemleri | Fabrika Fiber Altyapı';
    document.head.appendChild(ogTitle);

    const ogDescription = document.createElement('meta');
    ogDescription.setAttribute('property', 'og:description');
    ogDescription.content = 'Sakarya fiber kablo tamiri, fabrika fiber altyapı, fusion splicing, OTDR test, IP kamera sistemleri. Sakarya OSB güvenlik çözümleri.';
    document.head.appendChild(ogDescription);

    const ogUrl = document.createElement('meta');
    ogUrl.setAttribute('property', 'og:url');
    ogUrl.content = `${import.meta.env.VITE_SITE_URL}/bolgeler/sakarya`;
    document.head.appendChild(ogUrl);

    const ogType = document.createElement('meta');
    ogType.setAttribute('property', 'og:type');
    ogType.content = 'website';
    document.head.appendChild(ogType);

    const ogLocale = document.createElement('meta');
    ogLocale.setAttribute('property', 'og:locale');
    ogLocale.content = 'tr_TR';
    document.head.appendChild(ogLocale);

    // JSON-LD Schema
    const schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Fiber Ek - Sakarya",
      "description": "Sakarya'da fiber optik altyapı kurulumu, IP kamera sistemleri, yangın alarm ve güvenlik çözümleri",
      "areaServed": "Sakarya",
      "telephone": "+905537165561",
      "url": `${import.meta.env.VITE_SITE_URL}/bolgeler/sakarya`,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Sakarya",
        "addressRegion": "Sakarya",
        "addressCountry": "TR"
      }
    });
    document.head.appendChild(schema);

    return () => {
      document.head.removeChild(canonical);
      document.head.removeChild(ogTitle);
      document.head.removeChild(ogDescription);
      document.head.removeChild(ogUrl);
      document.head.removeChild(ogType);
      document.head.removeChild(ogLocale);
      document.head.removeChild(schema);
    };
  }, []);

  const faqs = [
    {
      question: 'Sakarya\'da fiber kablo tamiri hizmeti veriyor musunuz?',
      answer: 'Evet, Sakarya genelinde ve OSB bölgelerinde 7/24 acil fiber arıza müdahale hizmeti veriyoruz. Fiber kablo tamiri için 30-45 dakika içinde yerinde oluyoruz.'
    },
    {
      question: 'Sakarya OSB\'de fabrika fiber altyapı kurulumu yapıyor musunuz?',
      answer: 'Evet, Sakarya Organize Sanayi Bölgesi\'nde fabrika fiber altyapı kurulumu, fiber optik sonlandırma, fusion splicing hizmeti ve OTDR test sunuyoruz. OM3 OM4 fiber ek işlemlerinde uzmanız.'
    },
    {
      question: 'Sakarya\'da hangi güvenlik sistemlerini kuruyorsunuz?',
      answer: 'Sakarya\'da IP kamera sistemleri, hırsız alarm sistemleri, yangın alarm sistemleri, geçiş kontrol sistemleri, turnike ve bariyer sistemleri kurulumu yapıyoruz. Fabrikalar için entegre güvenlik çözümleri sunuyoruz.'
    },
    {
      question: 'Fiber optik sonlandırma işlemi ne kadar sürer?',
      answer: 'Standart fiber optik sonlandırma işlemi 1-2 saat içinde tamamlanır. Fusion splicing ve OTDR test dahil profesyonel hizmet sunuyoruz.'
    }
  ];

  return (
    <>
      <FAQSchema faqs={faqs} />
      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900">
        <Navbar />
        <FloatingButtons />

        {/* Hero Section */}
        <section className="relative pt-32 pb-20 overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/2269e864c1f1baeae44c0f76affc7425.jpg')] bg-cover bg-center opacity-20"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-blue-600/10 via-transparent to-slate-900/50"></div>
          
          <div className="container mx-auto px-4 relative z-10">
            <Breadcrumb 
              items={[
                { label: 'Ana Sayfa', path: '/' },
                { label: 'Bölgeler', path: '/' },
                { label: 'Sakarya', path: '/locations/sakarya' }
              ]} 
            />

            <div className="max-w-4xl mx-auto text-center mt-12">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
                Sakarya Fiber Optik ve Güvenlik Sistemleri
              </h1>
              <p className="text-xl text-gray-300 mb-8">
                Sakarya OSB ve Sanayi Bölgelerinde Profesyonel Fiber Kablo Tamiri, Fabrika Fiber Altyapı ve Güvenlik Çözümleri
              </p>
              <div className="flex flex-wrap gap-4 justify-center">
                <a 
                  href="tel:+905537165561"
                  className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  Hemen Ara
                </a>
                <a 
                  href="https://wa.me/905537165561"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-20 bg-slate-800/50">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              
              {/* Fiber Optik Hizmetleri */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-flashlight-line text-blue-500"></i>
                  Sakarya Fiber Optik Hizmetleri
                </h2>
                
                <p className="text-gray-300 mb-6 leading-relaxed">
                  Sakarya'da <strong>fiber kablo tamiri</strong>, <strong>fiber optik sonlandırma</strong> ve <strong>fusion splicing hizmeti</strong> sunuyoruz. Sakarya OSB, Adapazarı ve Arifiye'deki fabrikalarda 10+ yıllık tecrübemizle <strong>fabrika fiber altyapı</strong> kurulumu, <strong>OTDR test hizmeti</strong> ve <strong>acil fiber arıza</strong> müdahalei veriyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Fabrika Fiber Altyapı ve Fiber Ek Hizmeti</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  Sakarya OSB'deki üretim tesislerinde <strong>fabrika fiber altyapı</strong> projeleri gerçekleştiriyoruz. <strong>Fiber ek hizmeti</strong> ile yüksek hızlı internet bağlantısı sağlıyoruz. <strong>OM3 OM4 fiber ek</strong> işlemlerinde profesyonel fusion splicing cihazları kullanıyoruz. <strong>SC LC konnektör sonlandırma</strong> ve <strong>metro ethernet fiber ek</strong> projelerinde minimum kayıp değerleri garanti ediyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Fiber Kablo Tamiri ve Acil Müdahale</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  <strong>Fiber kablo tamiri</strong> konusunda uzman ekibimiz, Sakarya'daki fabrikalarda yaşanan fiber arızalarına 30-45 dakika içinde müdahale ediyor. <strong>Acil fiber arıza</strong> durumlarında 7/24 hizmet veriyoruz. <strong>Bina fiber kablo tamiri</strong> ve yeni fiber altyapı kurulumlarında A'dan Z'ye hizmet sunuyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">OTDR Test ve Fiber Hat Analizi</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  <strong>OTDR test hizmeti</strong> ile fiber optik hatlarınızdaki tüm bağlantı noktalarını, kayıp değerlerini ve zayıf noktaları tespit ediyoruz. Profesyonel ölçüm cihazlarımızla fiber altyapınızın sağlık durumunu detaylı raporlarla sunuyoruz.
                </p>

                <div className="grid md:grid-cols-2 gap-6 mt-8">
                  <Link to="/fiber-services/factory-fiber" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-building-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Fabrika Fiber Altyapı</h4>
                    <p className="text-gray-400 text-sm">Sanayi tesisleri fiber kurulum</p>
                  </Link>
                  <Link to="/fiber-services/fiber-cable-repair" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-tools-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Fiber Kablo Tamiri</h4>
                    <p className="text-gray-400 text-sm">7/24 acil arıza müdahalei</p>
                  </Link>
                </div>
              </div>

              {/* Güvenlik Sistemleri */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-shield-check-line text-blue-500"></i>
                  Sakarya Güvenlik Sistemleri
                </h2>
                
                <p className="text-gray-300 mb-6 leading-relaxed">
                  Sakarya'da <strong>IP kamera sistemleri</strong>, <strong>hırsız alarm sistemleri</strong>, <strong>yangın alarm sistemleri</strong>, <strong>geçiş kontrol sistemleri</strong>, <strong>turnike sistemleri</strong> ve <strong>bariyer sistemleri</strong> kurulumu yapıyoruz. Sakarya OSB'deki fabrikalar için entegre güvenlik projeleri geliştiriyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Sanayi Bölgesi Güvenlik Çözümleri</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  Sakarya'daki üretim tesislerinde yüksek çözünürlüklü <strong>IP kamera sistemleri</strong> kuruyoruz. <strong>Geçiş kontrol sistemleri</strong>, <strong>turnike sistemleri</strong> ve <strong>bariyer sistemleri</strong> ile fabrika girişlerinde personel ve araç kontrolü sağlıyoruz.
                </p>

                <div className="grid md:grid-cols-2 gap-6 mt-8">
                  <Link to="/security-systems/ip-camera-systems" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-camera-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">IP Kamera Sistemleri</h4>
                    <p className="text-gray-400 text-sm">Fabrika güvenlik kameraları</p>
                  </Link>
                  <Link to="/security-systems/access-control-systems" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-door-lock-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Geçiş Kontrol Sistemleri</h4>
                    <p className="text-gray-400 text-sm">Turnike ve bariyer çözümleri</p>
                  </Link>
                </div>
              </div>

              {/* FAQ */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-8">Sıkça Sorulan Sorular</h2>
                <div className="space-y-6">
                  {faqs.map((faq, index) => (
                    <div key={index} className="border-b border-slate-700/50 pb-6 last:border-0">
                      <h3 className="text-xl font-bold text-white mb-3">{faq.question}</h3>
                      <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="py-20 bg-slate-900/30">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-3xl font-bold text-white mb-8 text-center">Konum</h2>
              <div className="rounded-2xl overflow-hidden shadow-2xl border border-slate-700/50">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d194348.47916850024!2d30.378925!3d40.7569!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14ccafe3e3e3e3e3%3A0x3e3e3e3e3e3e3e3e!2sSakarya!5e0!3m2!1str!2str!4v1234567898"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Sakarya Harita"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}